<script>
    export default {
        props: ['mainForm', 'coupon'],
        data() {
            let exploitable = {
                fixed_discount: null,
                percent_discount: null,
            }

            let exploitable_code = null
            let exploitable_used = this.mainForm.exploitable_used

            if (! _.isEmpty(this.coupon)) {
                exploitable = this.coupon;
                exploitable_code = exploitable.code;
                exploitable_used = true;
            }

            return {
                form: this.mainForm,
                discount: this.mainForm.discount,
                exploitable_code,
                exploitable_message: '',
                exploitable_invalid_response: false,
                exploitable,
                exploitable_used,
                waitingForCoupon: false
            }
        },
        mounted() {
            // this.$nextTick(() => {
            if (! _.isEmpty(this.coupon)) {
                // this.applyDiscount();
                this.checkValidation();
            }
            // })

            this.$bus.$on('verify-coupon', () => {
                if(this.exploitable_used == true)
                    this.checkValidation();
            })

            this.$bus.$on('apply-discounts', () => {
                this.exploitable = this.coupon;
                this.exploitable_code = this.exploitable.code;
                this.exploitable_used = true;

                this.applyDiscount();
            })
        },
        methods: {
            getCouponPlaceholder(notUsedMsg, alreadyUsedMsg) {
                return this.mainForm.exploitable_used ? alreadyUsedMsg : notUsedMsg
            },
            generateHtml() {
                if (this.exploitable.fixed_discount) {
                    return "<legend class='text-center m-b-20'>" +
                        this.exploitable_message +
                        "</legend>" +
                        "<p>Sconto applicato: " +
                        "<strong>" +
                        this.exploitable.fixed_discount + "€" +
                        "</strong>" +
                        "</p>" +
                        "<p>Totale scontato: " +
                        "<strong>" +
                        (this.form.total > 0 ? this.form.total : 0 + "€") +
                        "</strong>" +
                        "</p>"
                } else if (this.exploitable.percent_discount) {
                    return "<legend class='text-center m-b-20'>" +
                        this.exploitable_message +
                        "</legend>" +
                        "<p>Sconto applicato: " +
                        "<strong>" +
                        this.exploitable.percent_discount + "%" +
                        "</strong>" +
                        "</p>" +
                        "<p>Totale scontato: " +
                        "<strong>" +
                        (this.form.total > 0 ? this.form.total : 0 + "€") +
                        "</strong>" +
                        "</p>"
                } else if (this.exploitable.price) {
                    return "<legend class='text-center m-b-20'>" +
                        this.exploitable_message +
                        "</legend>" +
                        "<p>Sconto applicato: " +
                        "<strong>" +
                        this.exploitable.price + "€" +
                        "</strong>" +
                        "</p>" +
                        "<p>Totale scontato: " +
                        "<strong>" +
                        (this.form.total > 0 ? this.form.total : 0 + "€") +
                        "</strong>" +
                        "</p>" +
                        (this.form.total < 0 ? '<small class="text-danger">' +
                            'Il costo del tuo voucher è superiore a quello dell\' acquisto di ' +
                            this.form.total * -1 + '€. </small>' +
                            '<small class="text-danger">' +
                            'Al termine dell\'acquisto sarà generato un nuovo voucher del valore sopra indicato.</small>' : '')
                }
                return ''
            },
            checkValidation() {
                var self = this;
                this.exploitable_message = ''
                this.exploitable_invalid_response = false
                this.waitingForCoupon = true

                if (this.mainForm.exploitable_used && ! this.exploitable_used) {
                    bootbox.alert("<legend class='text-center m-b-20'>Coupon / Voucher già inserito</legend>")
                    return;
                }

                axios({
                    method: 'post',
                    url: '/exploitables/',
                    data: {
                        code: this.exploitable_code,
                        total: this.form.total,
                    }
                }).then((response) => {
                    this.exploitable = response.data.exploitable;
                    this.exploitable_used = true;
                    // console.log(response.data);
                    
                    this.applyDiscount();
                    if(_.isEmpty(this.coupon)) {
                        let message = this.generateHtml()
                        bootbox.alert(message)
                    }
                }).catch((error) => {
                    // self.exploitable_message = error.response.data.exploitable_message;
                    self.exploitable_invalid_response = true;
                    window.alerts.error(error.response.data.exploitable_message)
                    let total = self.form.total
                    self.exploitable = {}
                    self.exploitable_used = false
                    self.form.exploitable_used = false
                    self.exploitable_code = ''
                    self.form.exploitable_code = ''
                    self.discount = 0
                    let {exploitable, exploitable_code, exploitable_used, discount} = self;
                    self.exploitable_invalid_response = false;
                    self.$emit('apply-discount', {
                        total,
                        exploitable_code,
                        exploitable_used,
                        exploitable,
                        discount
                    })

                    self.waitingForCoupon = false
                });
            },
            applyDiscount() {
                let total = this.form.total
                // console.log(this.exploitable, total)
                if (this.exploitable.fixed_discount) {
                    total -= this.exploitable.fixed_discount;
                    this.discount = this.exploitable.fixed_discount;
                } else if (this.exploitable.percent_discount) {
                    let discount = (total * (this.exploitable.percent_discount * 1)) / 100
                    total = total - discount
                    this.discount = discount
                } else if (this.exploitable.price) {
                    total -= this.exploitable.price;
                    this.discount = this.exploitable.price;
                }

                let {exploitable, exploitable_code, exploitable_used, discount} = this;
                total = total.toFixed(2);
                // this.$set(this, 'exploitable_code', '');
                this.$emit('apply-discount', {
                    total,
                    exploitable_code,
                    exploitable_used,
                    exploitable,
                    discount
                })
                this.waitingForCoupon = false
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/cart/CartCouponForm.vue